import React from 'react';
import { Result, Button } from 'antd';

const NetError: React.FC = () => {
  return (
    <div
      style={{
        height: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f0f2f5',
      }}
    >
      <Result
        status="500"
        title="500"
        subTitle="服务器异常，请联系管理员！"
        extra={
          <Button type="primary" onClick={() => window.location.reload()}>
            刷新重试
          </Button>
        }
      />
    </div>
  );
};

export default NetError;
